var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec0, _dec1, _dec10, _dec11, _dec12, _dec13, _dec14, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor0, _descriptor1, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _dec15, _dec16, _dec17, _dec18, _dec19, _dec20, _class2, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import objectArrayTrait from "../Decorators/objectArrayTrait";
import primitiveArrayTrait from "../Decorators/primitiveArrayTrait";
import primitiveTrait from "../Decorators/primitiveTrait";
import ModelTraits from "../ModelTraits";
export let LegendItemTraits = (_dec = primitiveTrait({
  name: "Title",
  description: "The title to display next to this legend item.",
  type: "string"
}), _dec2 = primitiveTrait({
  name: "Multiple Titles",
  description: "Multiple titles to display next to this legend item.",
  type: "string"
}), _dec3 = primitiveTrait({
  name: "Maximum multiple titles showed",
  description: "Maximum number of multiple titles to display next to this legend item. (Default is 10)",
  type: "string"
}), _dec4 = primitiveTrait({
  name: "Title",
  description: "The title to display above this legend item, i.e. marking the top of " + "a box on the legend.",
  type: "string"
}), _dec5 = primitiveTrait({
  name: "Title",
  description: "The title to display below this legend item, i.e. marking the bottom of " + "a box on the legend.",
  type: "string"
}), _dec6 = primitiveTrait({
  name: "Color",
  description: "The CSS color to display for this item. This property is ignored if " + "`Legend URL` is specified.",
  type: "string"
}), _dec7 = primitiveTrait({
  name: "Outline Color",
  description: "The CSS color with which to outline this item.",
  type: "string"
}), _dec8 = primitiveTrait({
  name: "Outline Width",
  description: "The width of outline in pixels",
  type: "number"
}), _dec9 = primitiveTrait({
  name: "Outline Style",
  description: "The style of outline using CSS outline-style values. Eg 'dotted', 'dashed', 'solid', 'double', 'groove', 'ridge', 'inset', 'outset'",
  type: "string"
}), _dec0 = primitiveArrayTrait({
  name: "Multiple Colors",
  description: "Multiple colors to show with this item in a grid arrangement.",
  type: "string"
}), _dec1 = primitiveTrait({
  name: "Image URL",
  description: "The URL of an image to display with this item.",
  type: "string"
}), _dec10 = primitiveTrait({
  name: "Marker",
  description: 'Maki marker ID to display with this item (eg "circle").',
  type: "string"
}), _dec11 = primitiveTrait({
  name: "Rotation",
  description: "The degrees to rotate legend item.",
  type: "number"
}), _dec12 = primitiveTrait({
  name: "Add Spacing Above",
  description: "True to add a bit of extra spacing above this item in order to separate it visually from the rest of the legend.",
  type: "boolean"
}), _dec13 = primitiveTrait({
  name: "Legend Image Height",
  description: "The height of the legend image.",
  type: "number"
}), _dec14 = primitiveTrait({
  name: "Legend Image Width",
  description: "The width of the legend image.",
  type: "number"
}), _class = class LegendItemTraits extends ModelTraits {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "title", _descriptor, this);
    _initializerDefineProperty(this, "multipleTitles", _descriptor2, this);
    _initializerDefineProperty(this, "maxMultipleTitlesShowed", _descriptor3, this);
    _initializerDefineProperty(this, "titleAbove", _descriptor4, this);
    _initializerDefineProperty(this, "titleBelow", _descriptor5, this);
    _initializerDefineProperty(this, "color", _descriptor6, this);
    _initializerDefineProperty(this, "outlineColor", _descriptor7, this);
    _initializerDefineProperty(this, "outlineWidth", _descriptor8, this);
    _initializerDefineProperty(this, "outlineStyle", _descriptor9, this);
    _initializerDefineProperty(this, "multipleColors", _descriptor0, this);
    _initializerDefineProperty(this, "imageUrl", _descriptor1, this);
    _initializerDefineProperty(this, "marker", _descriptor10, this);
    _initializerDefineProperty(this, "rotation", _descriptor11, this);
    _initializerDefineProperty(this, "addSpacingAbove", _descriptor12, this);
    _initializerDefineProperty(this, "imageHeight", _descriptor13, this);
    _initializerDefineProperty(this, "imageWidth", _descriptor14, this);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "title", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "multipleTitles", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "maxMultipleTitlesShowed", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 10;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "titleAbove", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "titleBelow", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "color", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "outlineColor", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "outlineWidth", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "outlineStyle", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor0 = _applyDecoratedDescriptor(_class.prototype, "multipleColors", [_dec0], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor1 = _applyDecoratedDescriptor(_class.prototype, "imageUrl", [_dec1], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "marker", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "rotation", [_dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 0;
  }
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "addSpacingAbove", [_dec12], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "imageHeight", [_dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 20;
  }
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "imageWidth", [_dec14], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 20;
  }
}), _class);
let LegendTraits = (_dec15 = primitiveTrait({
  type: "string",
  name: "Title",
  description: "A title to be displayed above the legend."
}), _dec16 = primitiveTrait({
  type: "string",
  name: "URL",
  description: "The URL of the legend image. If the URL suffix isn't one of the following `png|jpg|jpeg|gif|svg`, then `urlMimeType` must be defined - otherwise a hyperlink will be shown."
}), _dec17 = primitiveTrait({
  type: "number",
  name: "Scaling",
  description: "Scaling of the legend. For example, a high DPI legend may have scaling = `0.5`, so it will be scaled down 50%"
}), _dec18 = primitiveTrait({
  type: "string",
  name: "URL MIME Type",
  description: 'The MIME type of the `URL` legend image. For example `"image/png"`'
}), _dec19 = objectArrayTrait({
  name: "Items",
  description: "",
  type: LegendItemTraits,
  idProperty: "index"
}), _dec20 = primitiveTrait({
  type: "string",
  name: "Background color",
  description: "Apply background color to entire legend. This can be useful if legend is transparent and clashes with Terria colours. This will override `legendBackgroundColor`."
}), _class2 = class LegendTraits extends ModelTraits {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "title", _descriptor15, this);
    _initializerDefineProperty(this, "url", _descriptor16, this);
    _initializerDefineProperty(this, "imageScaling", _descriptor17, this);
    _initializerDefineProperty(this, "urlMimeType", _descriptor18, this);
    _initializerDefineProperty(this, "items", _descriptor19, this);
    _initializerDefineProperty(this, "backgroundColor", _descriptor20, this);
  }
}, _descriptor15 = _applyDecoratedDescriptor(_class2.prototype, "title", [_dec15], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor16 = _applyDecoratedDescriptor(_class2.prototype, "url", [_dec16], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor17 = _applyDecoratedDescriptor(_class2.prototype, "imageScaling", [_dec17], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 1;
  }
}), _descriptor18 = _applyDecoratedDescriptor(_class2.prototype, "urlMimeType", [_dec18], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor19 = _applyDecoratedDescriptor(_class2.prototype, "items", [_dec19], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor20 = _applyDecoratedDescriptor(_class2.prototype, "backgroundColor", [_dec20], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class2);
export { LegendTraits as default };